<template>
    <UserTabs
        :selected-user="selectedUser"
        :personal-team="userPersonalTeam"
        tab-key="feature-management"
    >
        <div class="mt-12 rounded-md bg-white p-6 text-gray-900 shadow-md">
            <div class="grid grid-cols-4"></div>
        </div>
    </UserTabs>
</template>

<script lang="ts" setup>
import type IUser from "@/types/Members/IUser";
import { router } from "@inertiajs/vue3";
import route from "ziggy-js";
import type ICurrentTeam from "@/types/Members/ICurrentTeam";
import { ref, watch } from "vue";
import { useTranslations } from "@/composables/useTranslations.ts";

const { t } = useTranslations();

const props = defineProps<{
    selectedUser: IUser;
    personalTeam: ICurrentTeam;
    userPersonalTeam: ICurrentTeam;
}>();
</script>
